import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var go = normalize.go(function (options) {
  var step = options.step,
    _success = options.success,
    _fail = options.fail,
    _complete = options.complete;
  if (step < 0) {
    tt.navigateBack({
      delta: Math.abs(step),
      success: function success() {
        _success && _success();
      },
      fail: function fail(res) {
        _fail && _fail(res);
      },
      complete: function complete(res) {
        _complete && _complete(res);
      }
    });
  } else {
    _fail && _fail({
      errMsg: 'step不能大于或等于0'
    });
    _complete && _complete({
      errMsg: 'step不能大于或等于0'
    });
  }
}, CONTAINER_NAME.BYTE);
export default go;